import React from 'react';
import {Field} from 'redux-form/immutable';
import {SelectField} from 'redux-form-antd'
import {
    required,
    nullValue1
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
const SseFamilyKind = props => {
    const ans = '家庭類型'
    const select_arr = [
        {
            value: '-1',
            label: '請選擇'
        },
        {
            value: '1',
            label: '雙親'
        },
        {
            value: '2',
            label: '單親'
        },
        {
            value: '3',
            label: '失親'
        }
    ]
    return (
        <div>
            <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label={ans}
                   options={select_arr} name="sse_family_kind" type="text"></Field>
        </div>
    )
}

export default SseFamilyKind


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseFamilyKind.jsx